var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import useTriggerAnalyticsEvent from '../../../helpers/triggerAnalyticsEvent';
import HandHoldingHeartGraphic from '../../../ui/common/HandHoldingHeartGraphic';
import { StyledFlex, StyledText, StyledTitle } from '../../../ui/subcomponents';
import { Stack } from 'syf-component-library/ui/spacing';
import { Routes } from '../../../const';
import useTranslation from '../../../hooks/use-translation';
import { ForbearanceContainerWrapper } from './subcomponents';
var Forbearance = function () {
    var i18n = useTranslation();
    useTriggerAnalyticsEvent({
        featureEvent: 'planForbearance',
        currentRoute: Routes.PLAN_FORBEARANCE
    });
    return (_jsx(ForbearanceContainerWrapper, { children: _jsx(StyledFlex, __assign({ direction: "column", alignItems: "center" }, { children: _jsxs(StyledFlex, __assign({ direction: "column", alignItems: "center" }, { children: [_jsx(HandHoldingHeartGraphic, {}), _jsx(Stack, { size: "xlarge" }), _jsx(StyledTitle, __assign({ weight: "bold", size: "medium", align: "center" }, { children: i18n('plan.forbearanceHeading') })), _jsx(Stack, { size: "xlarge" }), _jsx(StyledText, __assign({ align: "center", size: "regular" }, { children: i18n('plan.forbearanceBodyText') })), _jsx(Stack, { size: "xlarge" }), _jsx(StyledText, __assign({ align: "center", size: "regular" }, { children: i18n('plan.forbearanceContactText') }))] })) })) }));
};
export default Forbearance;
//# sourceMappingURL=index.js.map